<template>
  <b-navbar toggleable="lg" type="dark" id="menu">
    <div class="container">
      <router-link to="/" class="navbar-brand">
        <img :src="require('../assets/img/logo_small.png')"/>
      </router-link>

      <b-navbar-toggle target="nav-collapse">
        <span class="navbar-toggler-icon"></span>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown v-if="this.$root.logged" class="nav-item dropdown user-account" right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
                <i class="icon fa fa-user-circle-o"></i> Hi, {{ $localStorage.get('user_first_name') }}
            </template>

            <div v-show="$root.getUserType !== 'member'">
              <b-dropdown-item to="/users/events">
                <i class="icon fa fa-calendar"></i> &nbsp; My Events
              </b-dropdown-item>
            </div>
            <div v-show="$root.getUserType !== 'member'">
              <b-dropdown-item to="/users/gift_cards">
                <i class="icon fa fa-gift"></i> &nbsp; My Gift Cards
              </b-dropdown-item>
            </div>
            <b-dropdown-item to="/users/profile/my-profile">
              <i class="icon fa fa-pencil"></i> &nbsp; My Profile
            </b-dropdown-item>
            <b-dropdown-item to="/users/profile/change-password">
              <i class="icon fa fa-lock"></i> &nbsp; Change Password
            </b-dropdown-item>
            <b-dropdown-item to="/admin/application-settings" v-if="$root.getUserType === 'admin'">
              <i class="icon fa fa-cogs"></i> &nbsp; Admin
            </b-dropdown-item>
            <hr/>
            <b-dropdown-item href="javascript:;" v-on:click="$root.logout()">
              <i class="icon fa fa-sign-out"></i> &nbsp; Log out
            </b-dropdown-item>
          </b-nav-item-dropdown>

            <!-- Using 'button-content' slot -->
            <a v-else href="javascript:;" class="nav-link nav-btn" v-on:click="login()">
              <span>
                <i class="fa fa-sign-in" aria-hidden="true"></i>
                Login
              </span>
            </a>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navbar',
  data: function () {
    return {
      navSection: ''
    }
  },
  created: function () {
    this.navSection = this.$route.name
  },
  watch: {
    '$route' (to, from) {
      this.navSection = this.$route.name
    }
  },
  methods: {
    login () {
      this.$router.push('/authenticate')
    }
  }
}
</script>
